import React from "react";
import { Alert, Card, Descriptions, Divider, Space, Spin, Tag, Typography } from "antd";
import { SafetyCertificateOutlined, UserOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";

const { Text } = Typography;

export const PolizarioChubb = () => {
  const { chubbPoliza, loadingPolizario, vistaResultados } = useSelector(
    (state) => state.polizarioReducer
  );

  return (
    <Card size="small">
      <div className="crear-servicios-v2__section-header">
        <div className="crear-servicios-v2__section-header-title">
          <SafetyCertificateOutlined />
          <span>Polizario Chubb</span>
        </div>
      </div>

      {loadingPolizario ? (
        <div style={{ textAlign: "center", padding: 24 }}>
          <Spin />
        </div>
      ) : vistaResultados === 0 ? (
        <Alert message="Presione Buscar para consultar" type="info" showIcon />
      ) : chubbPoliza?.policyNumber ? (
        <Space direction="vertical" style={{ width: "100%" }}>
          <Space wrap>
            <Text strong style={{ fontSize: 15 }}>{chubbPoliza.policyNumber}</Text>
            <Tag>{chubbPoliza.packageDesc}</Tag>
          </Space>

          <Divider orientation="left" plain style={{ margin: "8px 0" }}>
            <Space><UserOutlined /><Text type="secondary" style={{ fontSize: 12 }}>Asegurado</Text></Space>
          </Divider>
          <Descriptions column={2} size="small">
            <Descriptions.Item label="Nombre" span={2}>{chubbPoliza.formalName}</Descriptions.Item>
            <Descriptions.Item label="Correo electrónico" span={2}>{chubbPoliza.email}</Descriptions.Item>
          </Descriptions>
        </Space>
      ) : (
        <Alert message="No se encontró la póliza" type="warning" showIcon />
      )}
    </Card>
  );
};
